import User from './User'
import Menu from './Menu'
import UserTypeGroup from './UserTypeGroup'
import Privacy from './Privacy'
import PrivacyCheck from './PrivacyCheck'
import Running from './Running'
import Token from './Token'
import EditShop from './EditShop'
import ConfirmPass from './ConfirmPass'
import ListMember from './ListMember'
import ManageUser from './ManageUser'
import LINEConfigSendMessage from './LINEConfigSendMessage'
import GoogleCalendarConfig from './GoogleCalendarConfig'
import MigrateShop from './MigrateShop'
export default {
  GoogleCalendarConfig,
  MigrateShop,
  User,
  Menu,
  UserTypeGroup,
  Privacy,
  PrivacyCheck,
  Running,
  Token,
  EditShop,
  ConfirmPass,
  ListMember,
  ManageUser,
  LINEConfigSendMessage
}



// WEBPACK FOOTER //
// ./src/components/System/index.js